import React from 'react';

const Spinner = () => {
  return <i className="le-icon-vector spinner ms-3"></i>;
};

export default Spinner;
